module.exports = __webpack_public_path__ + "img/flogstad_Dalen_Portland1.3e97423c.jpg";